<template>
	<div>
		<header>
			<h1>Edit Search Pack</h1>
		</header>
		<div>
			<SearchPackBundleForm :search-pack-bundle="activeItem" cta="Update Search Pack" method="patch"/>
		</div>
	</div>
</template>
<script>
import SearchPackBundleForm from "./forms/SearchPackBundleForm.vue";
import {createNamespacedHelpers} from "vuex";

const {mapActions, mapGetters} = createNamespacedHelpers("searchPackBundles");

export default {
	components: {
		SearchPackBundleForm,
	},

	computed: mapGetters([
		"activeItem",
	]),

	methods: mapActions([
		"activateModel",
	]),

	created() {
		this.activateModel(this.$route.params.searchPackBundle);
	},
};
</script>
